// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__31SgM","vLegacy":"SelectSecondary_vLegacy__xCv7w","error":"SelectSecondary_error__31HIx","disabled":"SelectSecondary_disabled__2fb-7"};